import * as React from 'react'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { UnknownMeetingRow } from '@sdr-agend/admin-schemas'

/**
 * UNKNOWN meetings table — Story 4.7a (Visual MVP).
 *
 * Lists meetings whose attendance callback was sent but the seller hasn't
 * answered yet. In 4.7a the `attendanceCallbackSentAt` column is always
 * `null` (Story 4.6 will populate it); we already render the column so the
 * visual contract is stable when 4.6 lands.
 */
export interface UnknownMeetingsTableProps {
  data: ReadonlyArray<UnknownMeetingRow>
}

function formatDateTime(iso: string | null): string {
  if (iso === null || iso === '') return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('pt-BR')
}

export function UnknownMeetingsTable({
  data,
}: UnknownMeetingsTableProps): React.ReactElement {
  if (data.length === 0) {
    return (
      <div
        className="flex h-32 items-center justify-center rounded-md border border-dashed text-sm text-muted-foreground"
        data-testid="unknown-meetings-empty"
      >
        Sem reuniões aguardando callback do vendedor.
      </div>
    )
  }

  return (
    <div className="rounded-md border" data-testid="unknown-meetings-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Cliente</TableHead>
            <TableHead>Reunião</TableHead>
            <TableHead>Callback enviado</TableHead>
            <TableHead>Vendedor</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.meetingId}>
              <TableCell>{row.customerName ?? '—'}</TableCell>
              <TableCell>{formatDateTime(row.scheduledAt)}</TableCell>
              <TableCell>{formatDateTime(row.attendanceCallbackSentAt)}</TableCell>
              <TableCell>{row.sellerName}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default UnknownMeetingsTable
